import { render, staticRenderFns } from "./DashboardMetrics.vue?vue&type=template&id=50f6e31a&"
import script from "./DashboardMetrics.vue?vue&type=script&lang=js&"
export * from "./DashboardMetrics.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMetrics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports